import {
  PermissionAction,
  PermissionScope,
  PermissionTableDataType,
} from 'dashboard/components/PermissionsTable/constants';
import { Permission } from 'lib/permissions';

export const DevelopmentSectionData: PermissionTableDataType = {
  sections: [
    {
      label: 'API',
      subSections: [
        {
          scopes: [PermissionScope.Environment],
          rows: [
            {
              label: 'API keys',
              tooltip: 'Allows this role to view, create, and expire API keys',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.ApiKeyView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.ApiKeyWrite,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'API logs',
              tooltip:
                'Allows this role to view logs of API calls made within environments enabled for the role',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.ApiLogList,
                      scopes: [PermissionScope.Environment],
                    },
                    {
                      permission: Permission.ApiLogsView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'Webhooks',
      subSections: [
        {
          scopes: [PermissionScope.Environment],
          rows: [
            {
              label: 'Webhook details',
              tooltip:
                'Allows this role to view, create, and edit webhooks, including rotating secrets for webhooks',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.WebhookView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.WebhookWrite,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Webhook events',
              tooltip: 'Allows this role to view and re-run webhook events',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.WebhookEventView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
                {
                  label: PermissionAction.Edit,
                  permissions: [
                    {
                      permission: Permission.WebhookEventWrite,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
